module.exports = __webpack_public_path__ + "static/media/cash_icon.ce9aa870.svg";